import React, { useState } from "react";
import FormActionButton from "../shared-components/FormActionButton";
import { formPages } from "../../constants";
import Text from "../shared-components/Text";
import { isValidMobile } from "../../utils/utils";

export default function CreditCheckSuccess({ compensate, onNext, onBack }) {
  const [mobile, setMobile] = useState(compensate.mobile || '');

  // console.log("compensate:", compensate);

  const [mobileNumberError, setMobileNumberError] = useState(false);

  return (
    <>
      <div className="fdc-form" data-testid="page-credit-check-success">
        <h2 className="title">
          Great news, {compensate?.firstName}! Your details have been submitted.
        </h2>
        <p className="mb-0">
          Your claim reference is: <span style={{ fontFamily: "Arial, sans-serif", fontWeight: "normal" }} className="unique-id-override">{compensate?.uniqueID}</span>
        </p>
      </div>
      <div className="fdc-form gif-input">
        <div className="row g-0">
          <div className="col-md-12">
            <div className="form-block">
              <p>
                Our specialist team is reviewing your details to retrieve all of
                your vehicle claims.{" "}
                <span style={{fontWeight: 800}}>
                  Next steps will be shared with you soon, we'll keep you
                  informed.
                </span>
              </p>
            </div>
          </div>
          {!compensate.mobile && (
            <>
              <div className="col-md-12">
                <div className="form-block">
                  <h2 style={{fontWeight: 700, fontSize: '24px'}}>Want important updates on your claim?</h2>
                  <p>
                    Please enter your mobile number below so we can keep you
                    informed every step of the way.
                  </p>
                  <Text
                    className={"mb-0"}
                    placeholder={"Enter your mobile number (Optional)"}
                    onChange={(e) => {
                      let sanitizedValue = e.target.value.replace(/\D/g, '');

                      // Limit to 11 digits
                      sanitizedValue = sanitizedValue.slice(0, 11);

                      setMobile(sanitizedValue);

                      // Clear any existing errors while user is typing
                      setMobileNumberError(false);
                    }}
                    value={mobile}
                    id={"Mobile Number"}
                    testId="credit-check-mobile"
                  />
                  {mobileNumberError?
                        <div className="error-message">
                          <p>Please enter a valid mobile number, it must start with 07 and be 11 digits long.</p>
                        </div>
                      :<></>
                    }
                </div>
              </div>
            </>
          )}
          <div className="col-md-12">
            <div className="form-block">
              <h2 style={{fontWeight: 700}}>Do you know your finance lender, vehicle registration, or vehicle make?</h2>
              <p>Please add them by clicking the button below. This helps us find all your claims worth up to <strong>£829</strong>* each. Don't worry, we'll locate any missing details for you.</p>
              <FormActionButton
                nextTitle="Add your vehicle or lender details"
                nextTestId="credit-check-btn-next"
                onNext={() => {
                  // Validate mobile number if provided (optional field)
                  if (mobile && mobile.length > 0 && !isValidMobile(mobile)) {
                    setMobileNumberError(true);
                    return;
                  }

                  // If mobile field is not shown or validation passes
                  onNext(
                    {
                      mobile: isValidMobile(mobile) ? mobile : '',
                    },
                    formPages.RequestFinanceLender
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
